import { useSelector } from "react-redux";

import { isLoaderActive } from "@/features/loader/loaderSlice";
import { Backdrop, CircularProgress } from "@mui/material";
import LoaderWithBackdrop from "./LoaderWithBackdrop";

const Loader = () => {
  const loader = useSelector(isLoaderActive);
  return <LoaderWithBackdrop loader={loader} />;
};

export default Loader;
